import { useContext } from 'react'
import { NotificationContext } from 'src/containers/notification-context'

const useNotification = () => {
  const { hide, notify } = useContext(NotificationContext)

  return { hide, notify }
}

export { useNotification }
